module.exports = __webpack_public_path__ + "static/media/IMG_4199.8cd02577.jpg";